/** ADR org key for Protected Employee profile on Unite emergency calls. */
export const PROTECTED_EMPLOYEE_ADR_ORG = 'protected_employee';

/**
 * Display name for the enrolled caller. BE never sends the roster identifier
 * so the caller's identity is not exposed to the ECC.
 */
export const PROTECTED_EMPLOYEE_DISPLAY_NAME = 'Protected Employee';

export const PROTECTED_EMPLOYEE_CARD_TITLE = 'Protected Employee';

export const PROTECTED_EMPLOYEE_CONSENT_LABEL = 'Shared with consent';

export const PROTECTED_EMPLOYEE_ENROLLMENT_SUBTITLE =
  'Enrolled in a corporate safety program';

export const PROTECTED_EMPLOYEE_SAFETY_CONTACT_LABEL = 'Safety contact';
